// DropdownSelect.js
import React, { useState } from 'react'
import styled from 'styled-components'

const DropdownSelect = ({
    name,
    options,
    selectedOptions,
    onOptionClick,
    placeholder = 'Sélectionnez une option',
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleMenu = () => setIsOpen(!isOpen)

    return (
        <Dropdown>
            <DropdownToggle onClick={toggleMenu}>
                {selectedOptions.length > 0
                    ? selectedOptions.join(', ')
                    : placeholder}
            </DropdownToggle>

            {isOpen && (
                <DropdownMenu>
                    {options.map((option) =>
                        option.subcategories.map((optionSubcategories) => (
                            <DropdownItem
                                key={optionSubcategories.name}
                                selected={selectedOptions.includes(
                                    optionSubcategories.name
                                )}
                                onClick={() =>
                                    onOptionClick(optionSubcategories.name)
                                }
                                color={optionSubcategories.backgroundColor}
                            >
                                {optionSubcategories.name}
                            </DropdownItem>
                        ))
                    )}
                    <DropdownItem
                        key={'noFilter'}
                        selected={selectedOptions.includes('all')}
                        onClick={() => onOptionClick('all')}
                    >
                        {'Sans filtre'}
                    </DropdownItem>
                </DropdownMenu>
            )}
        </Dropdown>
    )
}

// Styled Components
const Dropdown = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
`

const DropdownToggle = styled.button`
    width: 100%;
    height: 100%;
    padding: 10px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-align: left;
    &:hover {
        background-color: #0056b3;
    }
`

const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    width: 100%;
    background-color: white;
    border: 5px solid white;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 1);
    margin-top: 10px;
    border-radius: 5px;
`

const DropdownItem = styled.div`
    padding: 10px;
    background-color: ${({ color }) => (color ? color : 'white')};
    cursor: pointer;
    filter: ${({ selected }) => selected && 'brightness(0.5)'};
    &:hover {
        filter: 'brightness(0.9)';
    }
`

export default DropdownSelect
